import { Button, DataSource, Layout, Table} from "@mcleod/components";

export abstract class AutogenLayoutUserList extends Layout {
	buttonLock: Button;
	buttonRevoke: Button;
	buttonRevokeAll: Button;
	buttonUnlock: Button;
	sourceUsers: DataSource;
	tableSearch: Table;
}
